'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Usage {
  constructor(credentials, request, sdkConfiguration, customerId, suscriptionId) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager([customerId, suscriptionId]);
  }

  get(start_time = {}, end_time = {}) {
    this.requestManager.requestConfigurationManager.setApi('GetCustomerUsage');
    this.paramsManager.addQueryParam({ start_time }, { end_time });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }
}

module.exports = Usage;
